<div
  class="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8"
>
  <div
    class="max-w-4xl w-full space-y-8 bg-white py-16 px-5 md:px-10 rounded-xl shadow-lg"
  >
    <!-- Error Icon -->
    <div class="text-center">
      <div
        class="mx-auto flex items-center justify-center h-28 w-28 rounded-full bg-red-100 mb-4"
      >
        <svg
          class="size-12 text-red-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h2 class="text-3xl font-extrabold text-gray-900 mb-2">Payment Failed</h2>
      <p class="text-sm text-gray-500 mb-8">
        Transaction could not be completed
      </p>
    </div>

    <!-- Message -->
    <div class="text-center space-y-4">
      <p class="text-lg text-gray-700">
        We've experienced an issue processing your payment.
      </p>
      <p class="text-sm text-gray-600">
        Please check your payment details or contact your bank for assistance.
      </p>
    </div>

    <!-- Common Issues -->
    <div class="mt-8 bg-gray-50 rounded-lg p-6">
      <h3 class="text-md font-medium text-gray-900 mb-3">Common Issues:</h3>
      <ul class="text-sm text-gray-600 space-y-2 list-disc list-inside">
        <li>Insufficient funds</li>
        <li>Card declined by issuing bank</li>
        <li>Incorrect card information</li>
        <li>Transaction timeout</li>
      </ul>
    </div>

    <!-- Contact Info -->
    <div class="mt-8 bg-gray-50 rounded-lg p-6">
      <h3 class="text-md font-medium text-gray-900 mb-3">Need assistance?</h3>
      <p class="text-sm text-gray-600 mb-2">
        Contact our support team at:
        <a
          href="mailto:contact@onlyusedtesla.com"
          class="text-blue-600 hover:text-blue-800 font-medium"
        >
          contact&#64;onlyusedtesla.com
        </a>
      </p>
      <p class="text-sm text-gray-600">
        Our team typically responds within 24 hours.
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-4 mt-8">
      <button
        (click)="goToHome()"
        class="flex-1 py-2 px-4 border border-gray-300 rounded-md shadow-sm font-medium bg-blue-600 cursor-pointer text-white"
      >
        Return To Dashboard
      </button>
    </div>
  </div>
</div>
